import React, { useState, useEffect } from 'react';

export default function BannerPdpDetail(props) {
  const { productData, dataLocale, offerText } = props;
  const { BANNER } = dataLocale;
  const [offerDetails, setOfferDetails] = useState({});
  useEffect(() => {
    const obj = {};
    if (document.getElementById('productName')) {
      obj.productName = document.getElementById('productName').textContent;
    }
    if (document.getElementById('lenskartPrice')) {
      obj.lenskartPrice = document.getElementById('lenskartPrice').textContent;
    }
    if (document.getElementById('marketPrice')) {
      obj.marketPrice = document.getElementById('marketPrice').textContent;
    }
    setOfferDetails(obj);
  }, []);
  return (
    <div
      className="display-flex align-items-center justify-content-center padding-l30"
      style={{ flexDirection: 'column', height: '100%' }}
    >
      {productData && <img alt={BANNER} className="res-img" src={productData.image} />}
      <div
        className="margin-t24"
        style={{ width: '100%', background: 'lightgray', height: '1px' }}
      ></div>
      <div className="margin-t24 fs14 fw400">{offerDetails.productName}</div>
      <div className="margin-t24 fs12 fw700" style={{ color: '#2EC99F' }}>
        <span>{offerText}</span>
        <span className="margin-l5">{offerDetails.lenskartPrice}</span>
        <span
          className="fs12 fw400 margin-l5"
          style={{ textDecoration: 'line-through', color: '#C2C2C2' }}
        >
          {offerDetails.marketPrice}
        </span>
      </div>
    </div>
  );
}
